// src/PendingApprovalPage.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@400;600;700;800&family=Inter:wght@300;400;500&display=swap');
  .pending-root{min-height:100vh;background:#0a0a0f;display:flex;align-items:center;justify-content:center;font-family:'Inter',sans-serif;color:#f0ece4;padding:24px;}
  .pending-card{background:#111118;border:1px solid rgba(212,165,80,0.2);border-radius:20px;padding:52px 48px;max-width:480px;width:100%;text-align:center;box-shadow:0 24px 80px rgba(0,0,0,0.5);}
  .pending-icon{font-size:52px;margin-bottom:20px;display:block;}
  .pending-title{font-family:'Kanit',sans-serif;font-size:26px;font-weight:700;letter-spacing:0.03em;margin-bottom:12px;color:#f0ece4;}
  .pending-sub{font-size:15px;color:#8a8a9a;line-height:1.65;margin-bottom:32px;}
  .pending-sub strong{color:#d4a550;}
  .pending-steps{text-align:left;background:rgba(212,165,80,0.05);border:1px solid rgba(212,165,80,0.12);border-radius:12px;padding:20px 24px;margin-bottom:32px;}
  .pending-step{display:flex;align-items:flex-start;gap:12px;font-size:13px;color:#8a8a9a;margin-bottom:10px;line-height:1.5;}
  .pending-step:last-child{margin-bottom:0;}
  .pending-step-num{width:22px;height:22px;border-radius:50%;background:rgba(212,165,80,0.15);border:1px solid rgba(212,165,80,0.3);color:#d4a550;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;}
  .pending-logout{background:transparent;border:1px solid rgba(255,255,255,0.1);color:#8a8a9a;font-family:'Inter',sans-serif;font-size:13px;padding:10px 24px;border-radius:8px;cursor:pointer;transition:all 0.15s;margin-right:10px;}
  .pending-logout:hover{border-color:rgba(248,113,113,0.4);color:#f87171;}
  .pending-refresh{background:rgba(212,165,80,0.1);border:1px solid rgba(212,165,80,0.3);color:#d4a550;font-family:'Inter',sans-serif;font-size:13px;padding:10px 24px;border-radius:8px;cursor:pointer;transition:all 0.15s;}
  .pending-refresh:hover{background:rgba(212,165,80,0.18);border-color:rgba(212,165,80,0.5);}
`;

export default function PendingApprovalPage({ onLogout, onRefresh, rejected = false }) {
  const { t } = useTranslation();
  return (
    <div className="pending-root">
      <style>{S}</style>
      <div className="pending-card">
        {rejected ? (
          <>
            <span className="pending-icon">{t('pending.rejected_icon')}</span>
            <div className="pending-title">{t('pending.rejected_title')}</div>
            <p className="pending-sub" dangerouslySetInnerHTML={{ __html: t('pending.rejected_sub') }} />
            <div><button className="pending-logout" onClick={onLogout}>{t('pending.logout')}</button></div>
          </>
        ) : (
          <>
            <span className="pending-icon">{t('pending.pending_icon')}</span>
            <div className="pending-title">{t('pending.pending_title')}</div>
            <p className="pending-sub" dangerouslySetInnerHTML={{ __html: t('pending.pending_sub') }} />
            <div className="pending-steps">
              {['step1','step2','step3'].map((k,i) => (
                <div key={k} className="pending-step">
                  <div className="pending-step-num">{i+1}</div>
                  <span dangerouslySetInnerHTML={{ __html: t(`pending.${k}`) }} />
                </div>
              ))}
            </div>
            <div>
              <button className="pending-logout" onClick={onLogout}>{t('pending.logout')}</button>
              <button className="pending-refresh" onClick={onRefresh}>{t('pending.refresh')}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
